<template>
  <div>
    <div class="row">
      <div :class="getClass()" class="mb-4">
        <Card :title="$t('global.service')" class="mb-4">
          <CardDataHighlight
            :title="sharedHost.description"
            :subtitle="
              sharedHost.billing.frequency.charAt(0).toUpperCase() +
              sharedHost.billing.frequency.slice(1)
            "
            :data="`${moneyFormat(sharedHost.billing.amount)}`"
            color="tau"
          />
        </Card>
      </div>
      <div :class="getClass()" class="mb-4">
        <Card :title="$t('global.bandwidth')" class="mb-4">
          <CardTabledList :items="getBandwidthList()" />
        </Card>
      </div>
      <div v-if="safeHarborAllowed" class="col-md-4 mb-4">
        <SafeHarbor :service="sharedHost" />
      </div>
    </div>

    <AddonsTable v-if="showAddons()" :addons="sharedHost.addons" :status="status" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import AddonsTable from "@/components/smart/tables/AddonsTable";
import Card from "@/components/display/Card";
import CardDataHighlight from "@/components/display/card-sub-components/CardDataHighlight";
import CardTabledList from "@/components/display/card-sub-components/CardTabledList";
import { moneyFormat } from "leatherman-js/utils/formatters/money";
import SafeHarbor from "@/components/smart/cards/SafeHarbor";
import store from "@/store";

export default {
  name: "SharedHostOverview",
  components: {
    SafeHarbor,
    Card,
    CardDataHighlight,
    CardTabledList,
    AddonsTable,
  },
  props: {},
  setup(props, { root }) {
    const safeHarborAllowed = computed(() => store.getters["safeHarbor/isAllowed"]);
    const sharedHost = computed(() => store.getters["sharedHosts/getItem"]);
    const status = computed(() => store.getters["sharedHosts/getItemStatus"]);

    const getBandwidthList = () => [
      {
        key: root.$t("global.used"),
        value: `${sharedHost.value.bandwidth.used} / ${sharedHost.value.bandwidth.allotted} ${sharedHost.value.bandwidth.units}`,
      },
      {
        key: root.$t("global.projected"),
        value: `${sharedHost.value.bandwidth.lastPeriod.total} (${sharedHost.value.bandwidth.lastPeriod.billable}) ${sharedHost.value.bandwidth.units}`,
      },
      {
        key: root.$t("global.last-period"),
        value: `${sharedHost.value.bandwidth.lastPeriod.total} (${sharedHost.value.bandwidth.lastPeriod.billable}) ${sharedHost.value.bandwidth.units}`,
      },
    ];

    const getClass = () => (safeHarborAllowed.value ? "col-md-4" : "col-md-6");

    const getOverviewList = () => [
      {
        label: root.$t("global.ip-address"),
        content: sharedHost.value.ip,
        canCopy: true,
      },
      {
        label: root.$t("global.renewal-date"),
        content: sharedHost.value.billing.formattedNextBillDate,
      },
    ];

    const getServiceList = () => [
      {
        label: root.$t("global.level"),
        content: sharedHost.value.description,
      },
      {
        label: root.$t("global.price"),
        content: `${moneyFormat(sharedHost.value.billing.amount)} / ${
          sharedHost.value.billing.abbreviatedFrequency
        }`,
      },
    ];

    const showAddons = () => sharedHost.value?.addons?.length > 0;

    onMounted(() => {
      store.dispatch("safeHarbor/getAllowed", sharedHost.value.id);
    });

    return {
      getBandwidthList,
      getClass,
      getOverviewList,
      getServiceList,
      moneyFormat,
      safeHarborAllowed,
      sharedHost,
      showAddons,
      status,
    };
  },
};
</script>
